export default __webpack_public_path__ + "static/f3ff269f5709c512c48b8adf92ad04a8.png";